import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@lightning/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-0.5 w-full overflow-hidden",
      className
    )}
    style={{
      background: "#232232",
      borderRadius: "4px",
      marginTop: "6px",
      marginBottom: "12px"
    }}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 transition-all relative"
      style={{ 
        transform: `translateX(-${100 - (value || 0)}%)`,
        background: "#5D8AA8",
        borderRadius: "4px"
      }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
